import "./polyfills";
import React from "react";
import "./tailwind-setup.css";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import * as serviceWorker from "./serviceWorker";

import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import "react-data-grid/lib/styles.css";
import Main from "./Pages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_TRACES_SAMPLE_RATE = process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE;
const SENTRY_ENV =
  process.env.REACT_APP_DEPLOYMENT_ENV || process.env.REACT_APP_ENV || process.env.NODE_ENV;
const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

if (SENTRY_DSN) {
  const feedbackIntegration =
    typeof Sentry.feedbackIntegration === "function"
      ? Sentry.feedbackIntegration({
          autoInject: true,
          colorScheme: "system",
          buttonLabel: "Report a bug",
        })
      : undefined;

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new BrowserTracing(), ...(feedbackIntegration ? [feedbackIntegration] : [])],
    tracesSampleRate: Number(SENTRY_TRACES_SAMPLE_RATE || 0.1),
    environment: SENTRY_ENV,
    release: SENTRY_RELEASE,
  });
}

const store = configureStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => (
  <Provider store={store}>
    <HashRouter>
      <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
        <Component />
      </Sentry.ErrorBoundary>
    </HashRouter>
  </Provider>
);

const root = createRoot(rootElement).render(renderApp(Main));

if (module.hot) {
  module.hot.accept("./Pages/Main", () => {
    const NextApp = require("./Pages/Main").default;
    root.render(renderApp(NextApp));
  });
}
serviceWorker.unregister();
